import { render, staticRenderFns } from "./AgentRating.vue?vue&type=template&id=f79a1186&scoped=true&"
import script from "./AgentRating.vue?vue&type=script&lang=js&"
export * from "./AgentRating.vue?vue&type=script&lang=js&"
import style0 from "./AgentRating.vue?vue&type=style&index=0&id=f79a1186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79a1186",
  null
  
)

export default component.exports